export default "__VITE_ASSET__1Xx7ID5j__"